import { Avatar, Skeleton } from '@radix-ui/themes';
import { MlbStatsHelper } from 'classes/helpers/mlb-stats.helper';
import { GameDataContext } from 'contexts/game-data.context';
import { StringHelper } from 'lib_ts/classes/string.helper';
import { RadixAvatarSize } from 'lib_ts/enums/radix-ui';
import { useContext, useMemo } from 'react';

export const GameDataPlayerAvatar = (props: {
  size: RadixAvatarSize;
  // for URL
  playerPk: number | undefined;
  // for fallback
  name: string | undefined;
  loading?: boolean;
}) => {
  const { seasonPlayers } = useContext(GameDataContext);

  const color = useMemo(
    () =>
      seasonPlayers.find((p) => p.playerPk === props.playerPk)?._mx_team_details
        ?.colorHex ?? 'var(--gray-4)',
    [props.playerPk, seasonPlayers]
  );

  const textColor = useMemo(
    () =>
      StringHelper.getContrastColor(
        seasonPlayers.find((p) => p.playerPk === props.playerPk)
          ?._mx_team_details?.colorHex
      ),
    [props.playerPk, seasonPlayers]
  );

  const initials = useMemo(
    () => StringHelper.getInitials(props.name),
    [props.name]
  );

  const url = MlbStatsHelper.getPlayerHeadshotUrl(props.playerPk);

  return (
    <Skeleton loading={!!props.loading}>
      <Avatar
        src={url}
        fallback={initials}
        size={props.size}
        style={
          {
            background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%), ${color}`,
            backgroundBlendMode: 'normal, multiply, normal',
            color: textColor,
            border: url ? '1px solid var(--gray-3)' : undefined,
            '--avatar-fallback-color': textColor,
          } as React.CSSProperties
        }
      />
    </Skeleton>
  );
};
